import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme({
  styles: {
    global: () => ({
      body: {
        fontFamily: 'Open Sans, Avenir, Helvetica, Arial, sans-serif;',
      },
    }),
  },
  colors: {
    customBlue: {
      100: '#2151CC',
      500: '#003399',
    },
  },
  components: {
    Button: {
      variants: {
        primary: {
          bgGradient: 'linear(to-r, blue.400, blue.600)',
          color: 'white',
          _hover: {
            bgGradient: 'linear(to-r, blue.700, blue.800)',
            boxShadow: 'lg',
            sx: {
              boxShadow: '0 10px 15px -3px rgba(59, 130, 246, 0.3)',
            },
          },
          _disabled: {
            _hover: {
              color: 'blue.700',
            },
          },
        },
        secondary: {
          bg: 'blue.50',
          color: 'blue.700',
          border: '1px',
          borderColor: 'blue.500',
          _hover: {
            bg: 'blue.100',
            borderColor: 'blue.600',
          },
        },
      },
    },
  },
})
